import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth, formatApiErrorDetail } from "@/context/AuthContext";

export default function AdminLogin() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setBusy(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6">
      <form onSubmit={submit} className="w-full max-w-sm fade-up" data-testid="admin-login-form">
        <img src="/logo_wide.webp" alt="RED EYE" className="w-40 mx-auto mb-8 red-glow" />
        <h1 className="font-heading font-black uppercase text-2xl text-[#F0EDEA] text-center mb-6">Admin Login</h1>
        {error && <div className="bg-[#3a1414] border border-[#E60000] text-[#FF4550] text-sm rounded-lg px-4 py-3 mb-4" data-testid="login-error">{error}</div>}
        <label className="block text-[#A8A2A0] text-xs uppercase tracking-wide mb-1">Email</label>
        <input data-testid="login-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="w-full bg-[#1C1C1C] border border-[#333] rounded-xl h-12 px-4 text-[#F0EDEA] focus:border-[#E60000] outline-none mb-4" />
        <label className="block text-[#A8A2A0] text-xs uppercase tracking-wide mb-1">Password</label>
        <input data-testid="login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required className="w-full bg-[#1C1C1C] border border-[#333] rounded-xl h-12 px-4 text-[#F0EDEA] focus:border-[#E60000] outline-none mb-6" />
        <button type="submit" disabled={busy} className="btn-skew btn-primary w-full" data-testid="login-submit"><span>{busy ? "Signing in..." : "Sign In"}</span></button>
        <Link to="/admin/forgot-password" className="block text-center text-[#A8A2A0] text-sm mt-4 hover:text-[#E60000]" data-testid="forgot-link">Forgot password?</Link>
      </form>
    </div>
  );
}
